import * as types from '../constants/actionTypes'

const increment = () => ({
  type: types.INCREMENT
})

export default increment



/** WEBPACK FOOTER **
 ** ./src/actions/increment.js
 **/